// Beep curto gerado via Web Audio API -- sem depender de um arquivo de
// áudio. Dois tons curtos em sequência (efeito "ding-dong" discreto).
//
// Navegadores só deixam o AudioContext tocar som depois de um gesto real
// do usuário na página (clique, toque) -- se ele nascer "suspended" (por
// ter sido criado dentro de uma resposta de fetch do polling, sem gesto
// nenhum antes), `start()` não lança erro, mas também não solta som
// nenhum. Por isso `unlockNotificationSound` existe: chamar em qualquer
// clique da página garante que o contexto já está destravado bem antes
// da primeira notificação de verdade precisar tocar.
let audioContext: AudioContext | undefined;

const getAudioContext = (): AudioContext => {
  if (!audioContext) {
    audioContext = new (window.AudioContext ||
      (window as any).webkitAudioContext)();
  }

  return audioContext;
};

export const unlockNotificationSound = (): void => {
  try {
    const context = getAudioContext();

    if (context.state === 'suspended') {
      context.resume();
    }
  } catch (err) {
    console.log('Erro ao destravar áudio:', err);
  }
};

const playTone = (
  context: AudioContext,
  frequency: number,
  startTime: number,
  duration: number,
): void => {
  const oscillator = context.createOscillator();
  const gain = context.createGain();

  oscillator.type = 'sine';
  oscillator.frequency.value = frequency;

  gain.gain.setValueAtTime(0, startTime);
  gain.gain.linearRampToValueAtTime(0.2, startTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, startTime + duration);

  oscillator.connect(gain);
  gain.connect(context.destination);

  oscillator.start(startTime);
  oscillator.stop(startTime + duration);
};

export const playNotificationSound = (): void => {
  try {
    const context = getAudioContext();

    if (context.state === 'suspended') {
      // Sem gesto do usuário ainda -- não tem como tocar mesmo, mas
      // dispara o resume pra já destravar a próxima tentativa.
      context.resume();
      return;
    }

    const now = context.currentTime;

    playTone(context, 880, now, 0.15);
    playTone(context, 1108.73, now + 0.12, 0.18);
  } catch (err) {
    console.log('Erro ao tocar som de notificação:', err);
  }
};
